export const DEFAULT_PARAMS = {
    path: '/',
    maxAge: 60 * 60 * 24 * 7,
};

export const USER_LOCATION = 'app_user_region';

export const ELECTRO_STATIONS_USER = 'electro_stations_user';

export const CIB_CABINET_ADV_DATA = 'CIB_CABINET_ADV_DATA';

export const CIB_LEAD_FINGERPRINT = 'CIB_LEAD_FINGERPRINT';
export const CIB_LEAD_UTM = 'CIB_LEAD_UTM';
export const CIB_LEAD_VISIT_TIMESTAMP = 'CIB_LEAD_VISIT_TIMESTAMP';
export const CIB_LOAN_LEAD = (formType) => `CIB_LOAN_LEAD_${formType}`;
export const CIB_DCL_UID_SET = 'CIB_DCL_UID_SET';
